import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class SharedService {
    private selectedVersionSubject = new BehaviorSubject<any>(null);
    selectedVersion$ = this.selectedVersionSubject.asObservable();

    private selectedHierarchySubject = new BehaviorSubject<any>(null);
    selectedHierarchy$ = this.selectedHierarchySubject.asObservable();

    private latestVersionSubject = new BehaviorSubject<any>(null);
    latestVersion$ = this.latestVersionSubject.asObservable();

    userDataSubject = new BehaviorSubject<any>(null);
    userData$ = this.userDataSubject.asObservable();

    private selectedTaxonomySubject = new BehaviorSubject<any>(null);
    selectedTaxonomy$ = this.selectedTaxonomySubject.asObservable();

    private taxonomyListSubject = new BehaviorSubject<any[]>([]);
    taxonomyList$ = this.taxonomyListSubject.asObservable();

    private hierarchyListSubject = new BehaviorSubject<any[]>([]);
    hierarchyList$ = this.hierarchyListSubject.asObservable();

    private previousSelectedVersionSubject =
        new BehaviorSubject<any>(null);

    previousSelectedVersion$ =
        this.previousSelectedVersionSubject.asObservable();

    previousSelected = false;
    getSelectedVersion() {
        return this.selectedVersionSubject.value;
    }
    setSelectedVersion(version: any) {
        this.selectedVersionSubject.next(version);
    }
    getLatestVersion() {
        return this.latestVersionSubject.value;
    }
    setLatestVersion(version: any) {
        this.latestVersionSubject.next(version);
    }
    getSelectedHierarchy() {
        return this.selectedHierarchySubject.value;
    }
    setSelectedHierarchy(hierarchy: any) {
        this.selectedHierarchySubject.next(hierarchy);
    }
    getSelectedTaxonomy() {
        return this.selectedTaxonomySubject.value;
    }
    setSelectedTaxonomy(taxonomy: any) {
        this.selectedTaxonomySubject.next(taxonomy);
    }
    getTaxonomyList() {
        return this.taxonomyListSubject.value;
    }
    setTaxonomyList(list: any) {
        this.taxonomyListSubject.next(list ?? []);
    }
    getHierarchyList() {
        return this.hierarchyListSubject.value;
    }
    setHierarchyList(list: any) {
        this.hierarchyListSubject.next(list ?? []);
    }
    getPreviousVersion() {
        return this.previousSelectedVersionSubject.value;
    }
    setPreviousVersion(version: any) {
        this.previousSelectedVersionSubject.next(version);
    }
    clearAll() {
        this.selectedVersionSubject.next(null);
        this.latestVersionSubject.next(null);
        this.selectedHierarchySubject.next(null);
        this.selectedTaxonomySubject.next(null);
        this.taxonomyListSubject.next([]);
        this.hierarchyListSubject.next([]);
        this.previousSelectedVersionSubject.next(null);
    }
    setOldSelected(value: boolean) {
        this.previousSelected = value;
    }
    getOldSelected() {
        return this.previousSelected;
    }
}
